const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.LOYALTY_TRANSACTIONS)

export const apiLoyaltyTransation = {
	fetchLoyaltyTransations: async (): Promise<IApiResponseModel<IPointLoyaltyTransactionModel[]>> => {
		const { data, meta } = await apiCommon<IPointLoyaltyTransaction[]>(`${groupPrefix}`, { method: 'GET' })

		return { data: data.map(d => PointLoyaltyTransation(d)), meta }
	},
}
